
export const sysPageList = [
    { name: '首页', code: 'index', path: '/pages/index/index' },
    {
        name: '服务列表', code: 'goodsList', path: '/pages/goods-list/index',
        schema: {
            type: 'object',
            properties: {
                cateId: {
                    title: '类目',
                    type: 'string',
                    widget: 'ChooseCate',
                },
            }
        }
    },
    { 
        name: '搜索页', code: 'search', path: '/pages/search/index',
        schema: {
            type: 'object',
            properties: {
                cateId: {
                    title: '类目',
                    type: 'string',
                    widget: 'ChooseCate',
                },
            }
        }
    },
    { name: '个人信息页', code: 'personInfo', path: '/pages/person-info/index' },
    {
        name: '商品详情', code: 'goodsDetail', path: '/pages/goods-detail/index',
        schema: {
            type: 'object',
            properties: {
                goodsId: {
                    title: '选择商品',
                    type: 'string',
                    multi: false,
                    widget: 'ChooseGoods',
                    required: true
                },
            }
        }
    },
    {
        name: '次卡详情', code: 'goodsCardDetail', path: '/pages/goods-card-detail/index',
        schema: {
            type: 'object',
            properties: {
                cardTmpId: {
                    title: '选择次卡',
                    type: 'string',
                    multi: false,
                    widget: 'ChooseGoodsCard',
                    required: true
                },
            }
        }
    },
    {
        name: '优惠券详情', code: 'couponDetail', path: '/pages/coupon-detail/index',
        schema: {
            type: 'object',
            properties: {
                couponTmpId: {
                    title: '选择优惠券',
                    type: 'string',
                    multi: false,
                    widget: 'ChooseCoupon',
                    required: true
                },
            }
        }
    },
    {
        name: '福利商城(优惠券/次卡/团购列表)', code: 'benefit', path: '/pages/benefit/index', 
        schema: {
            type: 'object',
            properties: {
                couponTmpId: {
                    title: '具体页面',
                    type: 'string',
                    enum: [
                        "coupon",
                        "groupBuy",
                        "secondaryCard"
                    ],
                    enumNames: [
                        "优惠券",
                        "团购活动",
                        "次卡"
                    ]
                },
            }
        }
    },
];